import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { loadSingleBatch } from '@reducers/batch';

interface ProductionOrderDetailsPartProps extends ProductionOrderScreenProps {
  partId: number | null;
}

const ProductionOrderDetailsPartComponent: FC<ProductionOrderDetailsPartProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  partId,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      <PartListOrSingleItem partId={partId} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsPart = connect(({ details: { partId } }) => ({ partId }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsPartComponent);

export { ProductionOrderDetailsPart };
